import React, { useState, useEffect } from "react";

const ImageGrid = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const images = [
    {
      src: "https://m.economictimes.com/thumb/msid-89740317,width-1200,height-900,resizemode-4,imgsize-624482/ahead-of-market.jpg",
      title: "Investment Strategies",
    },
    {
      src: "https://img-2.outlookindia.com/outlook/outlook-money/story/8aee1c4cb4920ae0bcce8ca9bdc32220.jpg?w=640",
      title: "Financial Growth",
    },
    {
      src: "https://thorntons-wealth.co.uk/wp-content/uploads/2018/01/wealth-text-written-on-wooden-block-with-stacked-coins-.jpg",
      title: "Wealth Planning",
    },
    {
      src: "https://sksmartsol.com/wp-content/uploads/2023/05/Image-2-About-Us-min-scaled.jpg",
      title: "Smart Solutions",
    },
  ];

  // Check if the screen is mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Clean up
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Auto slide for mobile
  useEffect(() => {
    if (!isMobile) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isMobile, images.length]);

  // Handle manual navigation for mobile
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="w-full bg-gray-50 py-16 px-4 sm:px-6 lg:px-12 overflow-hidden">
      <h2
        style={{ lineHeight: "1.2" }}
        className="w-full text-center mb-6 text-3xl md:text-4xl font-bold text-primaryBgColor"
      >
        We Craft & Design Innovative Portfolio
      </h2>

      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col md:flex-row gap-4 overflow-hidden md:h-[500px]">
        {images.map((item, index) => (
          <div
            key={index}
            className={`relative rounded-xl overflow-hidden flex-1 transition-all duration-500 cursor-pointer ${
              activeIndex === index ? "flex-[3]" : "flex-[1]"
            }`}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <img
              src={item.src}
              alt={item.title}
              className="w-full h-full object-cover transition-all duration-500"
            />
            <div
              className={`absolute font-mokoto tracking-wider bottom-4 left-4 text-white text-base font-medium bg-black bg-opacity-50 px-4 py-2 rounded transition-opacity duration-300 ${
                activeIndex === index ? "opacity-100" : "opacity-0"
              }`}
            >
              {item.title}
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Carousel */}
      <div className="md:hidden relative">
        <div className="overflow-hidden rounded-xl h-[400px]">
          <div
            className="flex transition-transform duration-500 ease-in-out h-full"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {images.map((item, index) => (
              <div
                key={index}
                className="w-full flex-shrink-0 h-full relative"
              >
                <img
                  src={item.src}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute font-mokoto tracking-wider bottom-4 left-4 text-white text-base font-medium bg-black bg-opacity-50 px-4 py-2 rounded">
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full"
        >
          ‹
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full"
        >
          ›
        </button>

        {/* Dots Indicator */}
        <div className="flex justify-center mt-4 space-x-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full ${
                index === currentSlide ? "bg-gray-800" : "bg-gray-400"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGrid;






// import React, { useState } from "react";

// const ImageGrid = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const images = [
//     {
//       src: "https://m.economictimes.com/thumb/msid-89740317,width-1200,height-900,resizemode-4,imgsize-624482/ahead-of-market.jpg",
//       title: "Investment Strategies",
//     },
//     {
//       src: "https://img-2.outlookindia.com/outlook/outlook-money/story/8aee1c4cb4920ae0bcce8ca9bdc32220.jpg?w=640",
//       title: "Financial Growth",
//     },
//     {
//       src: "https://thorntons-wealth.co.uk/wp-content/uploads/2018/01/wealth-text-written-on-wooden-block-with-stacked-coins-.jpg",
//       title: "Wealth Planning",
//     },
//     {
//       src: "https://sksmartsol.com/wp-content/uploads/2023/05/Image-2-About-Us-min-scaled.jpg",
//       title: "Smart Solutions",
//     },
//   ];

//   return (
//     <section className="w-full bg-gray-50 py-16 px-4 sm:px-6 lg:px-12 overflow-hidden">
//       <h2
//         style={{ lineHeight: "1.2" }}
//         className="w-full text-center mb-6 text-3xl md:text-4xl font-bold text-primaryBgColor"
//       >
//         We Craft & Design Innovative Portfolio
//       </h2>

//       <div className="flex flex-col md:flex-row gap-4 overflow-hidden md:h-[500px]">
//         {images.map((item, index) => (
//           <div
//             key={index}
//             className={`relative rounded-xl overflow-hidden flex-1 transition-all duration-500 cursor-pointer ${
//               activeIndex === index ? "flex-[3]" : "flex-[1]"
//             }`}
//             onMouseEnter={() => setActiveIndex(index)}
//             onMouseLeave={() => setActiveIndex(null)}
//           >
//             <img
//               src={item.src}
//               alt={item.title}
//               className="w-full h-full object-cover transition-all duration-500"
//             />
//             <div
//               className={`absolute font-mokoto tracking-wider bottom-4 left-4 text-white text-base font-medium bg-black bg-opacity-50 px-4 py-2 rounded transition-opacity duration-300 ${
//                 activeIndex === index ? "opacity-100" : "opacity-0"
//               }`}
//             >
//               {item.title}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default ImageGrid;
